import React, { ComponentProps } from 'react';
import { PageListType } from '../PageListDetails.utils';
import { PageListTeaser } from '../partials/PageListTeaser';
import { asView } from '../../../_lib/ViewFetcher';
import { DisplayOptions, PageListDetailsSearchResults } from '../PageListDetails.types';
import { PageListAToZ } from '../partials/PageListAToZ';
import { PageListTable } from '../partials/PageListTable';

type PageListDefaultViewProps = {
  pageListDisplayType: string;
  displayOptions: DisplayOptions;
  searchResults: PageListDetailsSearchResults;
};

export function PageListDetailsDefaultView({
  pageListDisplayType,
  searchResults,
  displayOptions,
}: PageListDefaultViewProps) {
  switch (pageListDisplayType) {
    case PageListType.ATOZ:
      return (
        <PageListAToZ
          searchResults={searchResults}
          pageListAToZ={searchResults.pagelistatoz}
          facets={searchResults.facets}
          displayOptions={displayOptions}
          resetAllFiltersUrl={searchResults.resetAllFiltersUrl}
        />
      );
    case PageListType.TEASER:
      return (
        <PageListTeaser
          searchResults={searchResults}
          sort={searchResults.sort}
          pageItems={searchResults.pageItems}
          facets={searchResults.facets}
          items={searchResults.items}
          displayOptions={displayOptions}
          resetAllFiltersUrl={searchResults.resetAllFiltersUrl}
        />
      );
    case PageListType.TABLE:
    default:
      return (
        <PageListTable
          searchResults={searchResults}
          sort={searchResults.sort}
          pageItems={searchResults.pageItems}
          facets={searchResults.facets}
          childPages={searchResults.childPages}
          displayOptions={displayOptions}
          resetAllFiltersUrl={searchResults.resetAllFiltersUrl}
        />
      );
  }
}

export const FetchableDefaultView = asView(PageListDetailsDefaultView);
export type FetchableDefaultView = ComponentProps<typeof FetchableDefaultView>;
